import { useQuery } from '@tanstack/react-query';

import { getSaleAisle } from 'api/jalapeno';

import useAccountQuery from './useAccountQuery';

export const SALE_AISLE_QUERY_KEY = 'sale-aisle';

const useSaleAisleQuery = ({ queryProps } = {}) => {
    const { data: account } = useAccountQuery();
    const { chargeID } = account?.nextOrder ?? {};

    return useQuery({
        queryKey: [SALE_AISLE_QUERY_KEY, chargeID],
        queryFn: async () => {
            const response = await getSaleAisle(chargeID);
            return response?.data;
        },
        enabled: !!chargeID,
        ...queryProps,
    });
};

export default useSaleAisleQuery;
